/** @jsx jsx */
import { jsx, Flex } from 'theme-ui'
import { Link } from 'gatsby'
import { useBreakpoint } from '../../utils/useWindowWidth'
import { BrandLogoDesktop, BrandLogoMobile } from '../../icons/index'
import NavLink from './NavLink'
import { func, node } from 'prop-types'

const LogoHeader = ({ children, onClick }) => {
  const breakpoint = useBreakpoint()
  return (
    <header>
      <nav
        aria-label="main"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: 'primary',
          px: 5,
          py: [0, 4],
          height: ['56px', '50px', '72px'],
        }}
      >
        <Flex>
          {breakpoint === 'mobile' || breakpoint === 'tablet' ? (
            <Link
              aria-label="home"
              sx={{
                display: 'flex',
              }}
              to="/"
              onClick={async () => onClick && (await onClick())}
            >
              <BrandLogoMobile alt="Commonwealth Logo" />
            </Link>
          ) : (
            <NavLink
              to="/"
              aria-label="Home"
              onClick={async () => onClick && (await onClick())}
            >
              <BrandLogoDesktop />
            </NavLink>
          )}
        </Flex>
        {children}
      </nav>
    </header>
  )
}

LogoHeader.propTypes = {
  children: node,
  onClick: func,
}

export default LogoHeader
